import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
export const Card = ({ bodyClassName, children, className, title, titleClassName, titleLevel: TitleLevel = 'h3', style, }) => {
    return (_jsx("div", { className: classNames('card mb-3', className), style: style, children: _jsxs("div", { className: classNames('card-body', bodyClassName), children: [title && (_jsx(TitleLevel, { className: classNames('card-title', { h5: !titleClassName }, titleClassName), children: title })), children] }) }));
};
